export default __webpack_public_path__ + "static/media/Background 5_00052.7f1eb453.png";